// extracted by mini-css-extract-plugin
export var content = "_my-1";
export var fullScreen = "_my-0";